interface FavoriteItem {
  contentId: number;
  name: string;
  url: string;
  language: string;
}

interface FavoritesChangedDetail {
  items?: FavoriteItem[];
}

interface FavoritesResponse {
  items: FavoriteItem[];
}

const renderFavorites = (container: HTMLElement, items: FavoriteItem[]): void => {
  const list = container.querySelector<HTMLUListElement>(".m-hubFavorites__list");
  const emptyState = container.querySelector<HTMLElement>(".m-hubFavorites__empty");
  if (!list || !emptyState) {
    return;
  }

  while (list.firstChild) {
    list.removeChild(list.firstChild);
  }

  items.forEach((item) => {
    const listItem = document.createElement("li");
    const link = document.createElement("a");
    link.href = item.url;
    link.textContent = item.name;
    listItem.appendChild(link);
    list.appendChild(listItem);
  });

  emptyState.classList.toggle("is-hidden", items.length > 0);
  list.classList.toggle("is-hidden", items.length === 0);
};

const refreshFavorites = async (container: HTMLElement): Promise<void> => {
  const apiUrl = container.dataset.apiUrl;
  if (!apiUrl) {
    return;
  }

  try {
    const response = await fetch(apiUrl, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!response.ok) {
      return;
    }

    const result = (await response.json()) as FavoritesResponse;
    if (Array.isArray(result.items)) {
      renderFavorites(container, result.items);
    }
  } catch {
    return;
  }
};

document.addEventListener("favorites:changed", (event: Event) => {
  const detail = (event as CustomEvent<FavoritesChangedDetail>).detail;
  document.querySelectorAll<HTMLElement>(".js-hubFavorites").forEach((container) => {
    if (Array.isArray(detail?.items)) {
      renderFavorites(container, detail.items);
    } else {
      void refreshFavorites(container);
    }
  });
});
